module.exports = __webpack_public_path__ + "static/media/InfantSleep.13fcbde3.jpg";